export default __webpack_public_path__ + "static/media/Service_pic1.b56a5fe8.png";